/**
 * @author Kuitos
 * @homepage https://github.com/kuitos/
 * @since 2017-08-26
 */
import { postConstructSymbol } from '../meta';
export default (function (target, name) {
  var fn = target[name];
  target[postConstructSymbol] = fn;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/mmlpx/esm/core/dependency-inject/decorators/postConstruct.js
// module id = null
// module chunks = 